import { styles } from './template.scss';
import { styles as commonStyles } from '../../../assets/common.scss';
import { styles as helpersStyles } from '../../../assets/text-helpers.scss';
import { styles as styleHelpersStyles } from '../../../assets/style-helpers.scss';

export const templateXdrOverview = document.createElement('template');

templateXdrOverview.innerHTML = `
  <style>${styleHelpersStyles}</style>
  <style>${helpersStyles}</style>
  <style>${commonStyles}</style>
  <style>${styles}</style>

  <div class="xdr-overview-content">
    <div class="wrapper">
      <div class="layout-3-columns">
             <div>
                <div class="gz-card">
                <gz-summary-panel></gz-summary-panel>
                </div>
                <div class="gz-card">
                  <gz-suspected-actors-card-component></gz-suspected-actors-card-component>
                </div>
                <div class="gz-card">
                  <gz-tactics-and-techniques></gz-tactics-and-techniques>
                </div>
             </div>

             <div>
               <div class="gz-card" id="organizationImpactCard">
               </div>
               <div class="gz-card">
                  <gz-title id="highlights-title" fontSize="16" class="timeline text-uppercase" fontWeight="500"></gz-title>
                  <gz-timeline-group></gz-timeline-group>
               </div>
             </div>

              <div>
               <div class="gz-card">
                  <gz-response-panel></gz-response-panel>
               </div>
               <div class="gz-card" id="risk-incident-panel">
                  <gz-risk-incident-panel></gz-risk-incident-panel>
               </div>
             </div>
     </div>

     </div>

      <gz-side-menu id="sideMenu" menuwidth="400" closeOnClickOutside resizable="left" class="push-body-sidenav resize-content">
    </gz-side-menu>
  </div>
`;
